import { inject, Injectable, Type } from '@angular/core';
import {
  DynamicDialogComponent,
  DynamicDialogConfig,
  DynamicDialogRef,
  DynamicDialogTemplates,
  DialogService as PrimengDialogService
} from 'primeng/dynamicdialog';
import { DialogCloseIconComponent } from '../components/overlay/dialog/dialog-close-icon/dialog-close-icon.component';

@Injectable({ providedIn: 'root' })
export class DialogService {
  private dialogService = inject(PrimengDialogService);


  public open<T>(componentType: Type<T>, dialogConfig: DynamicDialogConfig): DynamicDialogRef<T> {
    return this.dialogService.open(componentType, {
      ...dialogConfig,
      templates: this.getTemplates(dialogConfig),
    });
  }

  public getInstance(ref: DynamicDialogRef): DynamicDialogComponent {
    return this.dialogService.getInstance(ref);
  }

  private getTemplates(dialogConfig: DynamicDialogConfig): DynamicDialogTemplates | undefined {
    return {
      closeicon: DialogCloseIconComponent,
      ...(dialogConfig.templates || {}),
    }
  }

}
